<template>
    <div id="shopping-list-container">
        <div class="shopping-list" v-for="(category, i) in shopping_list">
            <h6>{{ category.title }}</h6>
            <ul>
                <li v-for="(item, j) in category.items" :key="i + '_' + j">
                    <input :id="i + '_' + j" :name="i + '_' + j" type="checkbox" v-model="item.checked">
                    <label :for="i + '_' + j">
                        <div v-if="parseInt(category.id) !== 9999999">
                            <div style="cursor: pointer" @click="item.expanded = !item.expanded">{{ item | unit  }}
                                <span v-if="item.measure !== 'none' && item.measure !== 'custom'">{{ item.measure !== 'measure' ? item.measure_name + ' of' : item.measure_name }} {{ item.title }}</span>
                                <span v-else-if="item.measure === 'custom'">{{ item | pluralize }}</span>
                                <span v-else>{{ item.custom_shopping_description }} {{ item | pluralize }}</span>
                            </div>
                        </div>
                        <div v-else> <!-- pantry -->
                            <div style="cursor: pointer" @click="item.expanded = !item.expanded">
                                <span v-if="item.measure !== 'none' && item.measure !== 'custom'">{{ item.title }}</span>
                                <span v-else-if="item.measure === 'custom'">{{ item | pluralize }}</span>
                                <span v-else>{{ item.custom_shopping_description }} {{ item | pluralize }}</span>
                                <span style="font-size: 12px; color: grey; margin-left: 10px;">{{ item | unit  }} {{ item.measure_name }}</span>
                            </div>
                        </div>


                    </label>
                </li>
            </ul>
        </div>
        <!--
        <div class="shopping-list" v-for="category in categories">
            <h6>{{ category.title }}</h6>
            <ul>
                <li v-for="item in category.items">
                    <input id="item" type="checkbox" v-model="toggle">
                    <label for="item">{{ item }}</label>
                </li>
            </ul>
        </div>
        -->
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
var pluralize = require('pluralize')
export default {
    beforeCreate () {
        // if (this.$route.params.challenge_id) this.$store.dispatch('MealPlan/loadChallenge', this.$route.params.challenge_id)
    },
    name: 'shopping-list-display',
    computed: {
        ...mapGetters('ShoppingList', ['shopping_list']),
        ...mapGetters('MealPlan', ['weeks', 'challenge'])
    },
    filters: {
        unit (value) {
            if(['measure', 'gms', 'mls', 'none'].indexOf(value.measure) < 0) {
                return Math.ceil(value.percent / 100)
            }
            if(['kgs', 'ltrs'].indexOf(value.measure_name) >= 0) {
                return value.unit / 1000
            }
            return value.unit
        },
        pluralize (value) {
            if (value.unit < 2 || !value.pluralize) return value.title
            return pluralize(value.title)
        },
        percent_used (value) {
            //return value.percent
            if(['measure', 'gms', 'mls', 'none'].indexOf(value.measure) >= 0) {
                return 100
            }

            return (value.percent_used) / Math.ceil(value.percent / 100) * 100
        }
    }
}
</script>

<style lang="scss">
// flex align to the top on blank layout
body.body__recipe {
    align-items: start !important;
}
@import url('https://fonts.googleapis.com/css2?family=Roboto:wght@100;300;400;500&display=swap');

#shopping-list-container {
    all: initial; // reset everything so no other styles effect
    margin: 0 auto;
    width:80%;
    padding-top:20px;
    // start styling
    font-family: Roboto, sans-serif;

    .shopping-list {
        background:#CDEAED;
        padding:15px;
        padding-left: 25px;
        margin-bottom:15px;
        border-radius:4px;
        h6 {
            text-transform:uppercase;
            margin-bottom:25px;
            font-size: 1em;
            color: #666;
            font-weight: normal;
        }
        ul {
            list-style-type:none;
            padding-left:0px;
            li {
                margin-bottom:20px;
                font-weight:300;
                display:flex;
                align-items:center;
                input[type='checkbox'] {
                    cursor:pointer;
                    opacity:0;
                    position:absolute;
                    &:checked {
                        + label {
                            &::before {
                                content:'\2713';
                                background-color:#24adbb;
                                display:flex;
                                justify-content:center;
                                align-items:center;
                                color:#fff;
                            }
                        }
                    }
                }
                label {
                    cursor:pointer;
                    display:flex;
                    &::before {
                        content:'';
                        margin-right:10px;
                        width:20px;
                        height:20px;
                        border-radius:4px;
                        background:#fff;
                        border:thin solid rgba(0, 0, 0, 0.1);
                        box-shadow:0 3px 1px -2px rgba(0, 0, 0, 0.2), 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 1px 5px 0 rgba(0, 0, 0, 0.12);
                    }
                }
            }
        }
    }
}



</style>
